module.exports = __webpack_public_path__ + "media/director_meetings/status_none-b346730a.png";